module.exports = __webpack_public_path__ + "img/avatar.08803b0d.png";